import { DownloadPageLayout } from '@bpm-web-app/components';
import { News } from '@bpm-web-app/components/pages';

export default function NewsPage({ title }: { title: string }) {
    return (
        <DownloadPageLayout title={title}>
            <News newsProviderId={process.env.NEXT_PUBLIC_MAIN_BPM_NEWS_PROVIDER_ID} isCreate={false} />
        </DownloadPageLayout>
    );
}

export async function getStaticProps() {
    return {
        props: {
            title: 'News',
        },
    };
}
